import React, { Component } from 'react';
import Screenbeam from './Screenbeam/Screenbeam'

class WorkExperience extends Component {
  render() {
    return (
      <div id='WorkExperience'>
        <div className = 'header1'>Work Experience</div>
          <Screenbeam />
      </div>
    );
  }
}

export default WorkExperience;
